<template>
  <div class="logo_bg">
    <div class="logo_icon" @click="bakcHome"></div>
    <!-- <div class="logo_text">ENTERPRISE DATA MAP</div> -->
  </div>
</template>
<script lang="ts" setup>
import { useRouterHook } from '@/hooks/useRouter';
const { goto } = useRouterHook();
const bakcHome = () => {
  goto({
    name: '/main',
  });
};
</script>
<style scoped>
.logo_bg {
  padding-left: 30px;
  min-width: 280px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo_icon {
  width: 120px;
  height: 34px;
  background-image: url('@/assets/edm_logo_icon.png');
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
}

.logo_text {
  font-size: 14px;
  color: #666;
  font-weight: 700;
  user-select: none;
}
</style>
